import { Site } from "../types/site";

const isUsSite = (site: Site): boolean => site?.siteCountry?.toLowerCase() === "us" || site?.siteCountry?.toLowerCase() === "usa";

export { isUsSite };
